import map from './parser-map';
import helpers from '../helpers';

const outcomeMap = map.sport.bet.outcome;

class Outcome {
  constructor(rawObj) {
    this.id = rawObj[outcomeMap.id];
    this.description = rawObj[outcomeMap.description];
    this.name = rawObj[outcomeMap.name];
    this.shortName = rawObj[outcomeMap.shortName] || this.name;
    this.shortcut = rawObj[outcomeMap.shortcut];
    this.idBet = rawObj[outcomeMap.idBet];
    this.providerId = rawObj[outcomeMap.providerId];
    this.position = parseInt(rawObj[outcomeMap.position], 10) || helpers.maxInt;
  }
}

export default Outcome;
